import { setTokens, logout } from '../actions';
import { dAPI } from 'appSrc/api';

const userFields = [ 'userid', 'facebookId', 'password', 'emailAddress',
    'gender', 'birthday', 'timezone', 'deactivated', 'deactivatedDate',
    'displayName', 'slug', 'dateCreated', 'lastActive', 'verified', 'avatar',
    'location', 'website', 'description', 'bannerImage', 'facebook', 'twitter',
    'instagram', 'curatorPending', 'tutorialComplete', 'amazonsubaffiliateid',
    'blog', 'tumblr', 'digitalmagazine', 'youtube', 'pinterest', 'other',
    'medium', 'why', 'tutorialComplete', 'channels', 'usertype', 'intro_video' ];

const fetchingSelf = () => ( {
    type: 'REQUEST_SELF',
} );

const clearSelf = () => ( {
    type: 'CLEAR_SELF',
} );

const receiveSelf = ( user ) => ( {
    type: 'RECEIVE_SELF',
    user: user,
} );

const requestSelfLists = () => ( {
    type: 'REQUEST_SELF_LISTS',
} );

const receiveSelfLists = ( lists ) => ( {
    type: 'RECEIVE_SELF_LISTS',
    lists,
} );

const requestSelfFollowing = () => ( {
    type: 'REQUEST_SELF_FOLLOWING',
} );

const receiveSelfFollowing = ( following ) => ( {
    type: 'RECEIVE_SELF_FOLLOWING',
    following,
} );

const receiveSelfFollowers = ( followers ) => ( {
    type: 'RECEIVE_SELF_FOLLOWERS',
    followers,
} );

const updateSelf = ( user ) => ( {
    type: 'UPDATE_SELF',
    user: user,
} );
const updateSelfMeta = ( meta ) => ( {
    type: 'UPDATE_SELF_META',
    meta: meta,
} );

const setSelfError = ( error ) => ( {
    type: 'SET_SELF_ERROR',
    error,
} );

const receiveLikedListIds = ( likedLists ) => ( {
    type: 'RECEIVE_SELF_LIKED_LIST_IDS',
    likedLists,
} );

const receiveLikedProductIds = ( likedProducts ) => ( {
    type: 'RECEIVE_SELF_LIKED_PRODUCT_IDS',
    likedProducts,
} );

const receiveLikedArticleIds = ( ids ) => ( {
    type: 'RECEIVE_SELF_LIKED_ARTICLE_IDS',
    likedArticles: ids,
} );

const saveAccountSettings = function( data ) {
    return dispatch => {
        dispatch( fetchingSelf() );
        delete data.affiliateCodes;
        return dispatch( requestPatchSelf( data ) )
        .then( ( response ) => {
            dispatch( setSelfError( null ) );
            return response;
        } )
        .catch( ( e ) => {
            var errorMessage = e.response;
            switch ( e.response ) {
                case 'FailedToUpdateUser':
                    errorMessage = 'Changes were not saved. Please try again.';
                    break;
            }
            dispatch( setSelfError( errorMessage ) );
            return Promise.reject( e );
        } );
    };
};

//TODO: move to auth and have it auto-redirect to profile if the user does exist
const validateFacebookToken = function( data ) {
    return dispatch => {
        return dAPI.post( '/auth/facebook', data )
        .then( ( res ) => {
            dispatch( setSelfError( null ) );
            return res;
        } )
        .catch( ( e ) => {
            dispatch( setSelfError( e ) );
            return Promise.reject( e );
        } );
    };
};

const getSelf = function() {
    return ( dispatch ) => {
        dispatch( fetchingSelf() );
        return dAPI.get( '/users/me' )
        .then( ( user ) => {
            dispatch( setSelfError( null ) );
            window.localStorage.setItem( '_id', user.userid );
            //dispatch( requestLikedProductIds() );
            //dispatch( requestLikedArticleIds() );
            dispatch( getOwnFollowing() );
            dispatch( receiveSelf( user ) );
            return user;
        } )
        .catch( ( e ) => {
            dispatch( setSelfError( e ) );
            dispatch( logout() );
            return Promise.reject( e );
        } );
    };
};

const getOwnLists = function() {
    return dispatch => {
        dispatch( requestSelfLists() );
        return dAPI.get( dAPI.self() + '/lists?limit=9999' )
        .then( ( apiResponse ) => {
            dispatch( setSelfError( null ) );
            var responseData = apiResponse;
            dispatch( receiveSelfLists( responseData ) );
            return  responseData;
        } )
        .catch( ( e ) => {
            dispatch( setSelfError( e ) );
            return Promise.reject( e );
        } );
    };
};

const getOwnFollowing = function () {
    return dispatch => {
        dispatch( requestSelfFollowing() );
        return dAPI.get( dAPI.self() + '/followingid/' )
        .then( ( response ) => {
            dispatch( setSelfError( null ) );
            dispatch( receiveSelfFollowing( response.following ) );
            return response.following;
        } )
        .catch( ( e ) => {
            dispatch( setSelfError( e ) );
            return Promise.reject( e );
        } );
    };
};

const createSelf = function( data ) {
    return dispatch => {
        return dAPI.post( '/auth/signup', data )
        .then( ( response ) => {
            var data = response;
            dispatch( setSelfError( null ) );
            try {
                dispatch( setTokens( data.tokens ) );
                return( data );
            } catch (e) {
                console.warn( 'Failed to create user', e );
                return( data );
            }
        } )
        .catch( ( e ) => {
            console.warn( e );
            var errorMessage = e.response ? e.response : e;
            switch ( errorMessage ) {
                case 'UserNotCreated':
                    errorMessage = 'Sorry, you\'re account was not created. Please try again.';
                    break;
                case 'ErrorWithFBToken':
                    errorMessage = 'Could not create account via Facebook. Please try again.';
                    break;
                case 'MissingProfileDetails':
                    errorMessage = 'Profile details missing, please fill in all fields.';
                    break;
            }
            dispatch( setSelfError( errorMessage ) );
        } );
    };
};

const requestPatchSelf = function( data ) {
    return dispatch => {
        data = Object.constrain( data, userFields );
        return dAPI.patch( '/users/me', data )
        .then( ( response ) => {
            var user = response;
            dispatch( setSelfError( null ) );
            dispatch( updateSelf( user ) );
            return user;
        } )
        .catch( ( e ) => {
            var errorMessage = e.response;
            switch ( e.response.data ) {
                case 'FailedToUpdateUser':
                    errorMessage = 'Changes were not saved. Please try again.';
                    break;
            }
            dispatch( setSelfError( errorMessage ) );
            return Promise.reject( e );
        } );
    };
};

const followUser = function( userid ) {
    return dispatch => {
        return dAPI.post( `/follow/${ userid }` )
        .then( ( response ) => {
            return Promise.all( [
                response,
                dispatch( getOwnFollowing() ),
            ] );
        } );
    };
};

const unfollowUser = function( userid ) {
    return dispatch => {
        return dAPI.delete( `/unfollow/${ userid }` )
        .then( ( response ) => {
            return Promise.all( [
                response,
                dispatch( getOwnFollowing() ),
            ] );
        } );
    };
};

const requestLikedListIds = function() {
    return dispatch => {
        return dAPI.get( `${ dAPI.self() }/listlikes/ids` )
        .then( ( response ) => {
            var ids = response.map( ( item ) => {
                return item.listid;
            } );
            dispatch( receiveLikedListIds( ids ) );
            return ids;
        } );
    };
};

const requestLikedProductIds = function() {
    return dispatch => {
        return dAPI.get( `${ dAPI.self() }/desirelikes/ids` )
        .then( ( response ) => {
            var ids = response.map( ( item ) => {
                return item.desireid;
            } );
            dispatch( receiveLikedProductIds( ids ) );
            return ids;
        } );
    };
};

const requestLikedArticleIds = function() {
    return () => {
        return Promise.resolve();
    };
};

export const requestLikeArticle = function( articleId ) {
    return false;
    // return dispatch => {
    //     return dAPI.post( `/curated-articles/${ articleId }/likes` ).then( () => {
    //         return dispatch( requestLikedArticleIds() );
    //     } );
    // };
};

export const requestUnlikeArticle = function( articleId ) {
    return {}; //return false;
    // return dispatch => {
    //     return dAPI.delete( `/curated-articles/${ articleId }/likes` ).then( () => {
    //         return dispatch( requestLikedArticleIds() );
    //     } );
    // };
};

const requestLikeList = function( listid ) {
    return dispatch => {
        return dAPI.post( `/lists/${ listid }/likes` ).then( ( response ) => {
            dispatch( requestLikedListIds() );
            return response;
        } );
    };
};

const requestLikeProduct = function( productid ) {
    return dispatch => {
        return dAPI.post( `/desires/${ productid }/Desires` ).then( ( response ) => {
            dispatch( requestLikedProductIds() );
            return response;
        } );
    };
};

const requestUnlikeList = function( listid ) {
    return dispatch => {
        return dAPI.delete( `/lists/${ listid }/likes` ).then( ( response ) => {
            dispatch( requestLikedListIds() );
            return response;
        } );
    };
};

const requestUnlikeProduct = function( productid ) {
    return dispatch => {
        return dAPI.delete( `/desires/${ productid }/Desires` ).then( ( response ) => {
            dispatch( requestLikedProductIds() );
            return response;
        } );
    };
};

export {
    getSelf,
    updateSelf,
    updateSelfMeta,
    createSelf,
    saveAccountSettings,
    validateFacebookToken,
    requestPatchSelf,
    getOwnLists,
    clearSelf,
    getOwnFollowing,
    setSelfError,
    followUser,
    unfollowUser,
    receiveSelf,
    receiveSelfLists,
    receiveSelfFollowing,
    receiveSelfFollowers,
    requestLikeList,
    requestLikeProduct,
    requestUnlikeList,
    requestUnlikeProduct,
};
